<template>
        <div class=""  @click="gotopage" >
             <div class="avatar mb-1">
                <div  class="avatar-content">
                    <img :src="page.icon" alt="" width="50">
                </div>
            </div>
            <!-- <h2 class="fw-bolder">{{ page.status }}</h2> -->
            <p class="card-text">{{ page.name.slice(0,28) }}{{page.name.length>28 ? '...':''}}</p>
        </div>


</template>

<script>
import useDate from "@/services/utils/day";

export default {
    name: 'PageCard',

    props: ['page'],

    computed: {
        companyId () {
            return this.$route.params.companyId
        },
        moduleId () {
            return this.$route.params.moduleId
        },
        menuId () {
            return this.$route.params.menuId
        },
        pageId () {
            return this.page.id
        },
        basicParams () {
            return {
                companyId: this.companyId,
                moduleId: this.moduleId,
                menuId: this.menuId,
                pageId: this.pageId,
            }
        }
    },
    methods: {
        gotopage() {
            const date = useDate();

            if(this.page.route == 'accounts-list') {
                this.$router.push({name: this.page.route ,
                    params: {
                        ...this.basicParams,
                        accountType: 'asset'
                    }
                })
            }

            if(this.page.route == 'business-location') {
              this.$router.push({name: this.page.route ,
                params: {
                  ...this.basicParams,
                  accountType: 'fg_warehouse'
                }
              })
            }

            if(
                this.page.route == 'specification-list'
                ) {
                this.$router.push({name: this.page.route ,
                    params: {
                        ...this.basicParams
                    }
                })
            }

            if(this.page.route == 'business-list') {
                this.$router.push({name: this.page.route ,
                    params: {
                        ...this.basicParams
                    }
                })
            }

            if(this.page.route == 'inventory-list') {
                this.$router.push({name: this.page.route ,
                    params: {
                        ...this.basicParams,
                        accountType: 'finished_goods'
                    }
                })
            }

            if(this.page.route == 'day-book') {
                this.$router.push({name: this.page.route ,
                    params: {
                        companyId: this.companyId,
                        moduleId: this.moduleId,
                        menuId: this.menuId,
                        pageId: this.pageId
                    },
                    query: {
                        start: date.currentDate(),
                        end: date.currentDate(),
                        page: 1
                    }
                })
            }

            if(this.page.route == 'chart-of-accounts-ngoab') {
              this.$router.push({name: this.page.route ,
                params: {
                  ...this.basicParams,
                  accountType: 'expense'
                }
              })
            }

            if(this.page.route == 'general-ledger'
                || this.page.route == 'trial-balance'
                || this.page.route == 'balance-sheet'
                || this.page.route == 'fs-datasheet'
                || this.page.route == 'profit-loss'
                || this.page.route == 'income-expenditure'
                || this.page.route == 'journal-list'
                || this.page.route == 'voucher-list'
                || this.page.route == 'payment-voucher-list'
                || this.page.route == 'contra-voucher-list'
                || this.page.route == 'receipt-voucher-list'
                || this.page.route == 'purchase-list'
                || this.page.route == 'purchase-return-list'
                || this.page.route == 'purchase-return-add'
                || this.page.route == 'sales-return-list'
                || this.page.route == 'sales-return-add'
                || this.page.route == 'pay-bill-list'
                || this.page.route == 'money-receipt-list'
                || this.page.route == 'sales-list'
                || this.page.route == 'purchase-bill-add'
                || this.page.route == 'purchase-bill-pay'
                || this.page.route == 'invoice-electronics'
                || this.page.route == 'sales-invoice-add'
                || this.page.route == 'sales-invoice-receipt'
                || this.page.route == 'payable-register'
                || this.page.route == 'receivable-register'
                || this.page.route == 'tds-vds-register'
                || this.page.route == 'cash-bank-register'
                || this.page.route == 'stock-register'
                || this.page.route == 'stock-register-detailed-report'
                || this.page.route == 'stock-ledger'
                || this.page.route == 'stock-adjustment-report'
                || this.page.route == 'export-datasheet'
                || this.page.route == 'bank-reconciliation'
                || this.page.route == 'receipts-payments-report'
                || this.page.route == 'stock-transfer-list'
                || this.page.route == 'stock-adjustment-list'
                || this.page.route == 'party-ledger'
                || this.page.route == 'tag-register'
                || this.page.route == 'sales-order-list'
                || this.page.route == 'pending-project-initiate'
                || this.page.route == 'pending-delivery-challan-list'
                || this.page.route == 'work-status-report'
                || this.page.route == 'my-work-status-report'
                || this.page.route == 'project-timesheet-report'
                || this.page.route == 'product-costing-list'
                || this.page.route == 'production-list'
                ) {
                this.$router.push({name: this.page.route ,
                    params: {
                        ...this.basicParams
                    },
                    query: {
                        start: this.getFirstDate(),
                        end: this.getLastDate(),
                        page: 1
                    }
                })
            }

          if(
              this.page.route == 'contacts-all' ||
              this.page.route == 'contacts-employee' ||
              this.page.route == 'contacts-supplier' ||
              this.page.route == 'contacts-customer' ||
              this.page.route == 'contacts-member' ||
              this.page.route == 'add-contact' ||
              this.page.route == 'contact-profile' ||
              this.page.route == 'work-status-update'
          ) {
            this.$router.push({name: this.page.route ,
              params: {
                companyId: this.companyId,
                moduleId: this.moduleId,
                menuId: this.menuId,
                pageId: this.pageId
              }
            })
          }

          if(this.page.route == 'contacts-create') {
            this.$router.push({name: this.page.route ,
              params: {
                companyId: this.companyId,
                moduleId: this.moduleId,
                menuId: this.menuId,
                pageId: this.pageId
              }
            })
          }

          if(
            this.page.route == 'project-bva' ||
            this.page.route == 'donor-report-bva'
          ){
              this.$router.push({name: this.page.route ,
                  params: {
                      ...this.basicParams
                  },
                  query: {
                      start: this.getFirstDate(3),
                      end: this.getLastDate()
                  }
              })
          }

          if(this.page.route === 'profit-loss-analytics'){
              this.$router.push({name: this.page.route ,
                  params: {
                      ...this.basicParams
                  },
                  query: {
                      start: this.getFirstDate(5),
                      end: this.getLastDate()
                  }
              })
          }

          if (this.page.route == 'contact-register') {
            this.$router.push({
              name: this.page.route,
              params: {
                companyId: this.companyId,
                moduleId: this.moduleId,
                menuId: this.menuId,
                pageId: this.pageId
              },
              query: {
                page: 1
              }
            })
          }
            if(this.page.route === 'company-settings') {
                this.$router.push({name: this.page.route ,
                    params: {
                        companyId: this.companyId,
                        moduleId: this.moduleId,
                    }
                })
            }

        },

        getFirstDate (interval = 0) {
            const date = new Date();
            return new Date(date.getFullYear(), date.getMonth() - interval, 2).toISOString().split('T')[0];
        },
        getLastDate () {
            const date = new Date();
            return new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString().split('T')[0];
        }
    }


}
</script>

<style scoped>
  .avatar{
    width: 80px;
    height: 80px;
    border-radius: 10%;
    background-color: #FFFFFF;
  }
  .avatar img{
    border-radius: 0% !important;
  }

  .avatar-content{
    margin: auto !important;
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 15px;
    background-color: #f8f9fa;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }
  .avatar-content:hover{
    width: 80px;
    height: 80px;
    background-color: #e7f3ff;
    transform: scale(1.15);
  }

</style>
